@let request = $request();
@let requestRoute = ['/requests', request.requestNumber];

<style>
  td {
    min-width: 100px;
  }
</style>

<td
  tuiTd
  [style.border-inline-start]="
    '10px solid ' + request.statusId!.color + ' !important'
  "
>
  <p class="x-font-body-4">{{ request.requestNumber }}</p>
</td>

<td tuiTd [routerLink]="requestRoute" class="min-w-[150px]">
  <div class="flex flex-col gap-1">
    @for (
      product of request.alternativeProducts;
      track product.productAssocId
    ) {
      <div>
        <p class="x-font-body-4-bold">
          @if (product.scheduledAt) {
            {{ product.scheduledAt | date: 'HH:mm' }}
          } @else {
            {{ getProductTime(product) | releaseTimeParser }}
          }
        </p>
        <p class="x-font-body-4">
          {{
            product.displayDate
              ? (product.displayDate | date: getDateFormat(product.displayDate))
              : ('requests_list_item.undefined_date' | translate)
          }}
        </p>
      </div>
    }
  </div>
</td>

<td tuiTd>
  <p class="x-font-body-4 w-full">
    <img
      class="me-1.5 inline"
      [ngSrc]="counterpartyIconResolver(request.counterpartyOwnerId.id)"
      alt="cp icon"
      width="16"
      height="16"
    />
    {{
      request.contract || ('requests_list_item.undefined_contract' | translate)
    }}
  </p>
</td>

<td tuiTd>
  <div class="flex items-center">
    <x-svg-icon
      [icon]="leaseProductIconResolver(request.carType, request.carModel)"
      class="x-icon-svg car-type-icon-cp me-2"
    ></x-svg-icon>
    <p class="x-font-body-4 wrap-anywhere">
      {{
        request.car ||
          ('requests_list_item.undefined_lease_product' | translate)
      }}
    </p>
  </div>
</td>

<td tuiTd>
  <p class="x-font-body-4">
    {{
      request.carPlantNumber ||
        ('requests_list_item.undefined_car_plant_number' | translate)
    }}
  </p>
</td>

<td tuiTd>
  <p class="x-font-body-4">
    {{ request.vin || ('requests_list_item.no_vin' | translate) }}
  </p>
</td>

<td tuiTd>
  <p class="x-font-body-4">
    {{
      request.projectNumber ||
        ('requests_list_item.undefined_project_number' | translate)
    }}
  </p>
</td>

<td tuiTd [routerLink]="requestRoute" class="min-w-[220px]">
  <div class="flex flex-col gap-1">
    @for (
      product of request.alternativeProducts;
      track product.productAssocId
    ) {
      <p class="x-font-body-4">{{ product.productName }}</p>
    }
  </div>
</td>

<td tuiTd [routerLink]="requestRoute">
  <p class="x-font-body-4 wrap-anywhere">
    {{
      request.subjName ||
        ('requests_list_item.undefined_lease_recipient' | translate)
    }}
  </p>
</td>

<td tuiTd class="min-w-[280px]">
  <p
    class="x-font-body-4 wrap-anywhere"
    [ngClass]="{
      'x-text-green': deliveryAddressConfirmed,
      'x-text-yellow': deliveryAddressDifferentFromActual,
    }"
    [tuiHint]="getAddressHint() ? (getAddressHint() | translate) : ''"
    tuiHintAppearance="dark"
  >
    @if (deliveryAddressConfirmed) {
      <tui-icon
        icon="@tui.check"
        class="x-text-green size-6 text-base"
      ></tui-icon>
    }
    @if (deliveryAddressDifferentFromActual) {
      <tui-icon
        icon="@tui.circle-alert"
        class="x-text-yellow size-6 text-base"
      ></tui-icon>
    }
    {{
      request.deliveryAddress ||
        ('requests_list_item.undefined_address' | translate)
    }}
  </p>
</td>

<td tuiTd>
  <p class="x-font-body-4">
    {{
      request.installerShort || ('requests_list_item.not_assigned' | translate)
    }}
  </p>
</td>

<td tuiTd>
  <span
    tuiBadge
    class="x-font-body-5-bold-important text-[#494C62FF]!"
    appearance="custom"
    [style.background]="request.statusId?.color"
    >{{ 'request_statuses.' + request.statusId?.id | translate }}</span
  >
</td>

<td tuiTd>
  <p class="x-font-body-4">
    {{ request.createdAt | date: 'dd.MM.yyyy' }}
  </p>
</td>
